import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "mozaik",
  name: "Mozaik",
  tagline: "Kareleri patlat, gizli resmi aç; az hamlede bil.",
  inspiredBy: "Blast puzzle (Toon Blast / Royal Match)",
  secondLayer: "Tahmin: patlatılan kare gizli resmin aynı yerini açar; resmi erken bilmek puan.",
  accent: "#ffca3a",
  status: "live",
};
